<template>
  <div class="mc-fuel-alert-log mc-dashboard-card no-hover">
    <div class="form-check form-switch form-switch-md mc-fuel-alert-log__visibility">
      <input
        v-model="showLogNotification"
        class="form-check-input"
        type="checkbox"
        @change="showLogAction"
      />
      <span>{{ $t('dashboard.text.showNotificationLog') }}</span>
    </div>
    <div class="card">
      <McGrapqlTable
        v-if="showLogNotification"
        :key="tableKey"
        :fields="fields"
        :apiClient="apiClient"
        :hasCheckbox="false"
        :isSelectable="false"
        :cardPadding="false"
        :refreshData="refreshTable"
        trackBy="rawAlertId"
        class="mc-fuel-alert-log__table card-body"
      >
        <template #title>
          <div class="mc-fuel-alert-log__title">
            <h5>{{ titleText }}</h5>
            <span>{{ getFilterLabel }}</span>
          </div>
        </template>

        <template #custom-btn>
          <div class="form-check form-switch form-switch-md mc-fuel-alert-log__gain">
            <input
              v-model="showFuelGain"
              class="form-check-input"
              type="checkbox"
              @change="showFuelGainAction"
            />
            <span>{{ $t('dashboard.text.showFuelGain') }}</span>
          </div>
        </template>

        <template #cell(type)="data">
          <span :class="['mc-fuel-alert-log__type', `is-${data.item.typeVariant}`]">
            {{ data.item.typeLabel }}
          </span>
        </template>

        <template #cell(time)="data">
          <div class="mc-fuel-alert-log__time">
            <span>{{ formattingDate(data.item.createdOn) }}</span>
            <span>{{ momentTimeSeconds(data.item.createdOn) }}</span>
          </div>
        </template>

        <template #cell(volume)="data">
          <span v-if="ishaveOdoFuelSensor(data.item.vehicle.sensor)">-</span>
          <span v-else :class="['mc-fuel-alert-log__volume', `is-${data.item.typeVariant}`]">
            {{ data.item.volumeLabel }}
          </span>
        </template>
      </McGrapqlTable>
    </div>
  </div>
</template>

<script>
import McGrapqlTable from '@/components/McGrapqlTable'
import { Helper } from '@/mixin/helper'
import { NOTIFICATION_GENERAL_LIST } from '@/services/api/notification/general'
import moment from 'moment'
import { QueryCache } from '@/mixin/query-cache'
import { mapGetters } from 'vuex'
import { SENSOR_CODE } from '../../report/lib/variables'

moment.locale('id')

export default {
  components: { McGrapqlTable },
  mixins: [Helper],
  data() {
    return {
      showLogNotification: false,
      showFuelGain: false,
      filterLabel: '',
      tableKey: 0,
      refreshTable: false,
      period: [],
      queryCache: new QueryCache(),
      vgroupId: [],
      vehicleTypeId: [],
    }
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),
    getFilterLabel() {
      return this.filterLabel
    },
    fields() {
      return [
        {
          key: 'type',
          label: 'dashboard.label.type',
          thClass: 'mc-fuel-alert-log__col-type',
          isSortable: true,
          sortKey: 'alertCode',
        },
        {
          key: 'time',
          label: 'dashboard.label.time',
          thClass: 'mc-fuel-alert-log__col-time',
          isSortable: true,
          sortKey: 'createdOn',
        },
        {
          key: 'vehicle.licensePlate',
          label: 'dashboard.label.licensePlate',
          thClass: 'mc-fuel-alert-log__col-plate',
          isSortable: true,
        },
        {
          key: 'volume',
          label: 'dashboard.label.volume',
          thClass: 'mc-fuel-alert-log__col-volume',
          isSortable: false,
        },
      ]
    },
    apiClient() {
      return {
        get: async (filter) => {
          if (this.period.length != 2) {
            return {
              data: [],
              pagination: {
                page: 1,
                total: 0,
              },
            }
          }
          const alertCode = this.showFuelGain ? [13, 14] : [14]
          const res = await this.queryCache.fetch(
            NOTIFICATION_GENERAL_LIST,
            {
              filter: {
                ...filter,
                alertCode,
                startDate: moment(this.period[0] + ' 00:00:00.000').toISOString(),
                endDate: moment(this.period[1] + ' 23:59:59.000').toISOString(),
                vgroupId: this.vgroupId && this.vgroupId.length > 0 ? this.vgroupId : undefined,
                vehicleTypeId:
                  this.vehicleTypeId && this.vehicleTypeId.length > 0
                    ? this.vehicleTypeId
                    : undefined,
              },
            },
            ''
          )

          let rawAlerts = res.rawAlerts.rawAlerts
          return {
            ...rawAlerts,
            data: rawAlerts.data.map(this.mapFuelAlertRow),
          }
        },
      }
    },
    titleText() {
      return 'Log Notifikasi BBM'
    },
  },
  methods: {
    ishaveOdoFuelSensor(sensors) {
      return (
        sensors?.some((item) => item.sensorCode == SENSOR_CODE.FUEL_ODO) &&
        this.hasAccess(['b1x-new-fuel-expectation:read'])
      )
    },
    formattingDate(date) {
      return moment(date).format('DD MMM YYYY')
    },
    loadData(filter) {
      this.vgroupId = filter.vgroupId
      this.vehicleTypeId = filter.vehicleTypeId
      this.period = [filter.startDate, filter.endDate]
      this.updateFilterLabel()
      this.tableKey += 1
    },
    showLogAction() {
      this.refreshTable = !this.refreshTable
    },
    showFuelGainAction() {
      this.tableKey += 1
    },
    updateFilterLabel() {
      const preiodLabel = `${moment(this.period[0]).format('DD MMM YYYY')} - ${moment(
        this.period[1]
      ).format('DD MMM YYYY')}`
      const vgroupLabel =
        this.vgroupId && this.vgroupId.length > 0
          ? `${this.vgroupId.length} ${this.$t('dashboard.table.vehicleGroup')}`
          : this.$t('global.text.allVehicleGroup')
      const vtypeLabel =
        this.vehicleTypeId && this.vehicleTypeId.length > 0
          ? `${this.vehicleTypeId.length} ${this.$t('dashboard.table.vehicleType')}`
          : this.$t('global.text.allVehicleType')
      this.filterLabel = [preiodLabel, vgroupLabel, vtypeLabel].join(', ')
    },
    mapFuelAlertRow(item) {
      const isFuelGain = Number(item.alertCode) === 13

      return {
        ...item,
        typeLabel: isFuelGain
          ? this.$t('dashboard.text.refueling')
          : this.$t('dashboard.text.reduction'),
        typeVariant: isFuelGain ? 'gain' : 'loss',
        volumeLabel: this.getFuelAlertVolumeLabel(item, isFuelGain),
      }
    },
    getFuelAlertVolumeLabel(item, isFuelGain) {
      const rawVolume = item.formattedAlertData ?? item.alertData ?? 0
      const numericVolume = parseFloat(String(rawVolume).replace(',', '.'))

      if (Number.isNaN(numericVolume)) {
        return `${rawVolume} L`
      }

      const signedVolume = isFuelGain
        ? `+${this.minimizeFloat(Math.abs(numericVolume))}`
        : `-${this.minimizeFloat(Math.abs(numericVolume))}`

      return `${signedVolume} L`
    },
  },
}
</script>

<style scoped>
.mc-fuel-alert-log {
  color: #172b4d;
}

.mc-fuel-alert-log__visibility {
  align-items: center;
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
}

.mc-fuel-alert-log__visibility span,
.mc-fuel-alert-log__gain span {
  color: #344054;
  font-size: 12px;
  line-height: 18px;
}

.mc-fuel-alert-log__title {
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
}

.mc-fuel-alert-log__title h5 {
  color: #172b4d;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  margin: 0;
}

.mc-fuel-alert-log__title span {
  color: #667085;
  font-size: 11px;
  line-height: 16px;
}

.mc-fuel-alert-log__gain {
  align-items: center;
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
}

.mc-fuel-alert-log__type {
  align-items: center;
  display: inline-flex;
  font-weight: 600;
  gap: 8px;
}

.mc-fuel-alert-log__type::before {
  border-radius: 50%;
  content: '';
  display: inline-block;
  height: 6px;
  width: 6px;
}

.mc-fuel-alert-log__type.is-gain::before {
  background: #17a673;
}

.mc-fuel-alert-log__type.is-loss::before {
  background: #f04438;
}

.mc-fuel-alert-log__time {
  display: flex;
  flex-direction: column;
  line-height: 18px;
}

.mc-fuel-alert-log__time span:last-child {
  color: #98a2b3;
}

.mc-fuel-alert-log__volume {
  font-weight: 600;
}

.mc-fuel-alert-log__volume.is-gain {
  color: #17a673;
}

.mc-fuel-alert-log__volume.is-loss {
  color: #f04438;
}
</style>
